export default "__VITE_PUBLIC_ASSET__3ac55dc2__"